import { Injectable, inject } from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class I18nPaginatorIntl extends MatPaginatorIntl {
  private readonly translate = inject(TranslateService);

  constructor() {
    super();
    this.setLabels();

    this.translate.onLangChange.subscribe(() => {
      this.setLabels();
    });
  }

  setLabels() {
    this.itemsPerPageLabel = this.translate.instant("shared.paginator.items_per_page");
    this.nextPageLabel = this.translate.instant("shared.paginator.next_page");
    this.previousPageLabel = this.translate.instant("shared.paginator.previous_page");
    this.firstPageLabel = this.translate.instant("shared.paginator.first_page");
    this.lastPageLabel = this.translate.instant("shared.paginator.last_page");

    this.getRangeLabel = (page: number, pageSize: number, length: number) => {
      if (length === 0 || pageSize === 0) {
        return this.translate.instant("shared.paginator.range_empty", { length });
      }

      const startIndex = page * pageSize;
      const endIndex = Math.min(startIndex + pageSize, length);

      return this.translate.instant("shared.paginator.range_label", {
        start: startIndex + 1,
        end: endIndex,
        total: length,
      });
    };

    this.changes.next();
  }
}
